export default __webpack_public_path__ + "static/media/8-ViewConnectionsAtCompany.f61d2dcc.jpeg";